import { template } from "@ember/template-compiler";
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { task } from 'ember-concurrency';
import pageTitle from 'ember-page-title/helpers/page-title';
import RouteTemplate from 'ember-route-template';
import WrDivider from 'ember-wiser/components/wr/divider';
import WrLinkTo from 'ember-wiser/components/wr/link-to';
import WrModalContent from 'ember-wiser/components/wr/modal/content';
import AuthenticationLogin from 'parog-web/components/authentication/login';
import type SemeiaSessionService from 'parog-web/services/session';
let RouteComponent = class RouteComponent extends Component {
    @service
    session: SemeiaSessionService;
    loginTask = task(async (changeset1)=>{
        await this.session.authenticate('authenticator:patients-password', changeset1.pendingData);
    });
    static{
        template(`
    {{pageTitle 'Se connecter'}}

    <WrModalContent @targetModal='login-modal' @title='Connexion patient'>
      <div class='flex flex-col items-center gap-6'>

        <h2 class='text-h2 text-purple text-center font-sans'>
          Se connecter
          <br />
          avec votre compte existant
        </h2>

        <AuthenticationLogin @userType='patient' />

        <WrDivider>ou</WrDivider>

        <WrLinkTo @route='login.patient-link'>
          Je reçois un lien de connexion
        </WrLinkTo>

        <WrLinkTo @route='login.patient-password-forgotten'>
          Je crée mon mot de passe
        </WrLinkTo>
      </div>
    </WrModalContent>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
};
export default RouteTemplate(RouteComponent);
